import { useEffect } from 'react';

const useEngNumInput = (inputRef) => {
  const handleKeyDown = (e) => {
    const alphanumericPattern = /[a-zA-Z0-9@\.\-\s]/;
    const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Backspace', 'Delete'];

    if (!alphanumericPattern.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault(); 
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', handleKeyDown);
      return () => {
        inputRef.current.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [inputRef]);

  return handleKeyDown;
};

export default useEngNumInput;
